import React, { forwardRef } from "react";

import cn from "classnames";

import { InputWithFade } from "../../../../helpers/common/InputWithFade/InputWithFade";
import { createDisplayNameForInputTextElement } from "../../utils/getDisplayName";
import { createTestIdForInputTextElement } from "../../utils/getTestId";

import type { InputTextPropsWithTextMask } from "../../types";

import classes from "./InputTextInput.styl";

const INPUT_TEXT_INPUT_TEST_ID = createTestIdForInputTextElement("input");

export const Input = forwardRef<HTMLInputElement, InputTextPropsWithTextMask>(
    ({ size, type = "text", className, ...props }, ref) => {
        const rootClasses = cn(
            classes.input,
            size && classes[`__size-${size}`],
            className,
        );

        return (
            <InputWithFade
                {...props}
                type={type}
                className={rootClasses}
                data-tsid={INPUT_TEXT_INPUT_TEST_ID}
                ref={ref}
            />
        );
    },
);

Input.displayName = createDisplayNameForInputTextElement("Input");
